import { eventChannel } from 'redux-saga'

function createParticipantConnection(room) {
    return eventChannel(emitter => {
        const handler = participant => {
            emitter({ participant })
        }

        room.addListener('participantConnected', handler)

        return () => {
            room.removeListener('participantConnected', handler)
        }
    })
}

function createParticipantDisconnection(room) {
    return eventChannel(emitter => {
        const handler = participant => {
            emitter({ participant })
        }

        room.addListener('participantDisconnected', handler)

        return () => {
            room.removeListener('participantDisconnected', handler)
        }
    })
}

function createDominantSpeakerChanged(room) {
    return eventChannel(emitter => {
        const handler = participant => {
            emitter({ participant })
        }

        room.addListener('dominantSpeakerChanged', handler)

        return () => {
            room.removeListener('dominantSpeakerChanged', handler)
        }
    })
}

function createNetworkQualityLevelChanged(participant) {
    return eventChannel(emitter => {
        const { identity } = participant

        const handler = level => {
            emitter({ identity, level })
        }

        participant.addListener('networkQualityLevelChanged', handler)

        return () => {
            participant.removeListener('networkQualityLevelChanged', handler)
        }
    })
}

function createParticipantTrackSubscribed(participant) {
    return eventChannel(emitter => {
        const { identity } = participant

        const handler = track => {
            emitter({ identity, track })
        }

        participant.addListener('trackSubscribed', handler)

        return () => {
            participant.removeListener('trackSubscribed', handler)
        }
    })
}

function createParticipantTrackUnsubscribed(participant) {
    return eventChannel(emitter => {
        const { identity } = participant

        const handler = track => {
            emitter({ identity, track })
        }

        participant.addListener('trackUnsubscribed', handler)

        return () => {
            participant.removeListener('trackUnsubscribed', handler)
        }
    })
}

function createParticipantTrackState(identity, track) {
    return eventChannel(emitter => {
        const enabledHandler = () => {
            emitter({ identity, track, enabled: true })
        }

        const disabledHandler = () => {
            emitter({ identity, track, enabled: false })
        }

        track.addListener('enabled', enabledHandler)
        track.addListener('disabled', disabledHandler)

        return () => {
            track.removeListener('enabled', enabledHandler)
            track.removeListener('disabled', disabledHandler)
        }
    })
}

export {
    createParticipantConnection,
    createParticipantDisconnection,
    createDominantSpeakerChanged,
    createNetworkQualityLevelChanged,
    createParticipantTrackSubscribed,
    createParticipantTrackUnsubscribed,
    createParticipantTrackState,
}
